/* eslint-disable no-console */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { API_URL, userAgent, BASE_URL_V4, Sample_house_details } from '../../../api/api-config';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import Loader from '../../shared-ui/Loader';
import HouseDetailsPopup from '../houseDetailsPopup';
import SharePopUp from '../sharePopup';
import BackIcon from '../../../asset/images/white_back.svg';
import ShareIcon from '../../../asset/images/share_icon.svg';
import { axiosInstance } from '../../../api/coreApi';

class ViewFullScreen extends Component {

  constructor (props) {
    super(props);
    this.fetchHouseDetails=this.fetchHouseDetails.bind(this);
    this.gobacktoapp=this.gobacktoapp.bind(this);
    this.viewSharePopUp=this.viewSharePopUp.bind(this);
    this.closeSharePopUp=this.closeSharePopUp.bind(this);
    this.delayComponent=this.delayComponent.bind(this);
    this.viewDesignDoc=this.viewDesignDoc.bind(this);
    this.fetchProfileHouseDetails = this.fetchProfileHouseDetails.bind(this);
    this.viewHouseDetails = this.viewHouseDetails.bind(this);
    this.state = {
      modelUrl : '',
      isLoading: true,
      showSharePopUp: false,
      showComponents: false,
      paymentStatus: false,
      showHouseDetails: false,
      twoDUrl: '',
      showTwoD: false
    };
  }
  
  gobacktoapp () {
    const { history } = this.props;
    const houseId = localStorage.getItem('houseId');
    if(!this.state.paymentStatus) {
      history.push(`/home-details?house-id=${houseId}`);
    } else {
      this.viewDesignDoc();
    }
  }

  viewDesignDoc () {
    const houseId = localStorage.getItem('houseId');
    const shareToken = localStorage.getItem('shareToken');
    const langCode = localStorage.getItem('lang');
    const sampleDoc = window.location.toString().includes('sample-doc');
    const { history } = this.props;
    if (sampleDoc) {
      history && history.push(`/sample-document?preferred_language=${langCode}&user_agent=${userAgent}`);
    } else {
      history && history.push(`/design-document?house_id=${houseId}&share_token=${shareToken}&preferred_language=${langCode}&user_agent=${userAgent}`);
    }
  }

  viewHouseDetails () {
    this.setState({
      showHouseDetails: true
    });
  }

  viewSharePopUp () {
    this.setState({
      showSharePopUp: true
    });
  }

  delayComponent () {
    setTimeout(() => {
      this.setState({
        showComponents: true
      });
    }, 1000);
  }

  closeSharePopUp () {
    this.setState({
      showSharePopUp: false
    });
  }

  componentDidMount () {
    const sampleDoc = window.location.toString().includes('sample-doc');
    const twoDModelDoc = window.location.toString().includes('sample-doc-2D') || window.location.toString().includes('2D');
    if (twoDModelDoc) {
      this.setState({
        showTwoD: true
      });
    }
    if (sampleDoc) {
      this.fetchProfileHouseDetails();
    } else {
      this.fetchHouseDetails();
    }
  }
  
  fetchHouseDetails () {
    this.setState({
      isLoading: true
    });
    const { history } = this.props;
    const houseId = localStorage.getItem('houseId');
    const url = `${API_URL.house}/${houseId}`;
    axiosInstance.get(url).then((resp) => {
      const data = resp && resp.data && resp.data.data;
      if (data) {
        this.setState({
          twoDUrl: data.two_model_url, //to be updated 
          modelUrl: data.model_url,
          isLoading: false,
          paymentStatus: data.payment
        });
        this.delayComponent();
      }
    }).catch((err) => {
      console.log('err---->>>', err);
      if(err.response.data.status == 'Token is Expired' || err.response.data.status == 'Token is Invalid' || err.response.data.status == 'Authorization Token not found') {
        localStorage.clear();
        history.push('/login', { expiredError: true });
      }
      this.setState({
        isLoading: false
      });
    });
  }

  fetchProfileHouseDetails () {
    this.setState({
      isLoading: true
    });
    let url = '';
    /*********   url for sample-document  **********/
    url = `${BASE_URL_V4 + API_URL.userHouseProfile}?house_id=${Sample_house_details.houseID}&share_token=${Sample_house_details.ShareToken}&preferred_language=${localStorage.getItem('lang')}`;
    
    axiosInstance
      .get(url)
      .then((resp) => {
        const houseData = resp && resp.data && resp.data.data.house_info;
        if (houseData) {
          this.setState({
            twoDUrl: houseData.two_model_url, //to be updated
            modelUrl: houseData.model_url,
            isLoading: false,
            paymentStatus: houseData.house_payment,
          });
          this.delayComponent();
        }
      })
      .catch((err) => {
        if (err && err.response) {
          const errData = err.response && err.response.data;
          if (errData && errData.status && errData.status.toLowerCase() == 'failed') {
            this.setState({
              brokenLink: true,
            });
          }
        }
      });
  }


  render () {
    
    const { isLoading, modelUrl, showTwoD, twoDUrl, showHouseDetails, showSharePopUp, showComponents } = this.state;
    const { t } = this.props;

    return (
      <div>
        {showHouseDetails ? <HouseDetailsPopup
          close={() => this.setState({ showHouseDetails:false })} /> : null }
        {showComponents ?
          <div className='back_btn_wrapper'
            onClick={this.gobacktoapp}>
            <div className='back_icon'>
              <img src={BackIcon} />
            </div>
            <div className='fslbl'
              onClick={this.gobacktoapp}>{t('back')}
            </div>
          </div> : null }
        {showComponents ?
          <div className='share_btn_wrapper_one'>
            <div className='share_icon'
              onClick={this.viewSharePopUp}>
              <img src={ShareIcon} />
            </div>
            <div className='fslbl'
              onClick={this.viewSharePopUp}>{!showTwoD ? t('shareModel'): t('share_drawing')}</div>
            {showSharePopUp &&
              <SharePopUp closeSharePopUp={this.closeSharePopUp}
                text={t('share_design_desc')}
                shareUrl={ !showTwoD ? this.state.modelUrl : this.state.twoDUrl }
                shareText={true} />}
          </div> : null }
        {showTwoD && showComponents ?
          <div className='share_btn_wrapper'>
            <div className='share_icon'
              onClick={this.viewHouseDetails}>
              <img src={ShareIcon} />
            </div>
            <div className='fslbl'
              onClick={this.viewHouseDetails}>{t('drawing_details_c')}</div>
          </div> : null }
        <div className='show-full-screen'>
          {!showTwoD ?
            <iframe src={modelUrl}
              height='100%'
              width='100%' /> :
            <iframe src={twoDUrl}
              height='100%'
              width='100%' />}
        </div>
        <Loader
          isLoading={isLoading} />
      </div>
      
      
    );
  }
}

export default withTranslation()(withRouter(ViewFullScreen));